import React, { useContext, useEffect, useState } from "react";

import PropertyCrudComp from "./../properties/hoa-property-crud-comp";
import TableLayout from "../table-layout/hoa-table-layout";
import SuccessMessage from "../success-message/hoa-success-message";
import FilteringComponenet from "../filtering-component/hoa-filtering-comp";

import { GlobalContext } from "../../context/hoa-global-context";
import propertyTaskServices from "../../services/hoa-property-task-service";
import useAbortController from '../../hooks/useAbortController';
import { useSelectedTaskStoreStore } from "../../store/useTaskStore";

import "./../properties/hoa-property.scss";

export default function PropertyDashboard() {
	const {
		property,
		updateView,
		updateSelectedValues,
		view: views,
	} = useContext<any>(GlobalContext);

	const { resetDataList } = useSelectedTaskStoreStore();

	const [view, setView] = useState(views !== "view-more-details" ? "list" : "view");
	const [success, setSuccess] = useState(false);
	const [message, setMessage] = useState("");

	const signal = useAbortController()

	const filteringTitle= "Properties Pending Task";
	const filteringSubTitle= "View & manage all the recently added properties Task";
	const headers = [
		"Operator Name",
		"Document",
		"Property ID",
		"External ID",
		"Property Address",
		"Organization",
		"Type",
		"Last Updated",
		// "Added By",
		"",
	];
	const columns = [
		"user",
		"taskSourceType",
		"objectId",
		"hoaPropertyDetails",
		"fullAddress",
		"organizationName",
		"taskSourceType",
		"updatedAt",
		// "addedBy",
		"hover",
	];

	const getProperties = async (numberOfProperties: number, pageNo: number) => {
		const { data } = await propertyTaskServices.getPropertyTasks(
			pageNo,
			numberOfProperties,
			property.options,
			signal
		);
		return {
			data: data,
			count: 0,
		};
	};

	useEffect(() => {
		if(view === 'list') {
			console.log("rest")
			resetDataList()
		}
	}, [views])

	useEffect(() => {
		if (views === "add") {
			setMessage("Property Created Succesfully");
		} else if (views === "update") {
			setMessage("Property Updated Succesfully");
		} else if (views === "back-to-list") {
			setView("list");
			updateView("list");
			return;
		} else if (views === "remove-from-list") {
			setMessage("Property Removed Succesfully");
			setView("list");
			updateView("list");
			return;
		} else if (views === "view-more-details") {
			setView("view");
			updateView("view");
			return;
		}
		updateView(view);
	}, [
		view,
		views === "back-to-list",
		views === "remove-from-list",
		views === "view-more-details",
	]);

	return (
		<>
			{view === "list" ? (
				<>
					<FilteringComponenet
						onAddClick={setView}
						title={filteringTitle}
						subTitle={filteringSubTitle}
						tagType={"PropertyTask"}
					/>
					<TableLayout
						fetchResult={getProperties}
						headers={headers}
						columns={columns}
						tagType={"Property"}
						updateView={setView}
						updateSelectedValues={updateSelectedValues}
					/>
				</>
			) : (
				<PropertyCrudComp setSuccess={setSuccess} view={view} setView={setView} />
			)}

			<SuccessMessage success={success} setSuccess={setSuccess} message={message} />
		</>
	);
}
